
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/point-of-sale/page/[page]",
      function () {
        return require("private-next-pages/point-of-sale/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/point-of-sale/page/[page]"])
      });
    }
  